export { customerQueryOptions, useCustomerQuery } from './useCustomerQuery';
export type { UseCustomerQueryProps, Customer, CustomerPhoto } from './types';
